import { Workflow, Users, Code2, ShieldCheck, Quote } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { FadeUp, SectionHeading } from "@/components/Reveal";

const ICONS = { Workflow, Users, Code2, ShieldCheck };

const WhyBangde = () => {
    const { content } = useSite();
    const { why } = content;

    return (
        <section id="about" data-testid="why-bangde-section" className="bg-white py-20 sm:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <SectionHeading eyebrow="Why Bangde" heading={why.heading} sub={why.sub} />

                <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    {why.points.map((point, i) => {
                        const Icon = ICONS[point.icon] || ShieldCheck;
                        return (
                            <FadeUp key={point.title} delay={i * 0.1}>
                                <article
                                    data-testid={`why-point-${i}`}
                                    className="h-full rounded-2xl border border-slate-200 bg-mist p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
                                >
                                    <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-navy">
                                        <Icon className="h-5 w-5 text-amberct" aria-hidden="true" />
                                    </span>
                                    <h3 className="mt-4 font-display text-base font-bold text-navy sm:text-lg">{point.title}</h3>
                                    <p className="mt-2 text-sm leading-relaxed text-slate-600">{point.text}</p>
                                </article>
                            </FadeUp>
                        );
                    })}
                </div>

                <FadeUp delay={0.15}>
                    <figure data-testid="founder-blurb" className="mx-auto mt-14 max-w-3xl rounded-2xl bg-navy p-8 sm:p-10">
                        <Quote className="h-8 w-8 text-amberct" aria-hidden="true" />
                        <blockquote className="mt-4 font-display text-lg font-medium leading-relaxed text-white sm:text-xl">
                            {why.founder.quote}
                        </blockquote>
                        <figcaption className="mt-6 flex items-center gap-4">
                            {why.founder.photo ? (
                                <img src={why.founder.photo} alt={`${why.founder.name}, ${why.founder.role}`} data-testid="founder-photo" className="h-14 w-14 rounded-full border-2 border-amberct object-cover" />
                            ) : (
                                <span data-testid="founder-avatar" className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border-2 border-amberct bg-white/10 font-display text-lg font-extrabold text-amberct" aria-hidden="true">
                                    {why.founder.name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase()}
                                </span>
                            )}
                            <span>
                                <span className="block text-sm font-bold text-white">{why.founder.name}</span>
                                <span className="block text-xs text-slate-400">{why.founder.role}</span>
                            </span>
                        </figcaption>
                    </figure>
                </FadeUp>
            </div>
        </section>
    );
};

export default WhyBangde;
